import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Button } from 'reactstrap';
import { getFormatterForKodif, getNumberFormatter } from "../grid/ColumnHelpers";
import { dzeramaUdensSatecesBaseinsActions, dzeramaUdensSatecesBaseinsInMapSelected, toggleDzeramaUdensSatecesBaseinsArhivets } from '../../actions/dzeramaUdensSatecesBaseiniActions';
import { getKlasifikatorsFieldCfg } from '../forms/FormHelpers';
import { searchAction } from '../../actions/helpers';
import Loading from '../Loading';
import Form from '../forms/Form';
import TypeaheadField from '../forms/TypeaheadField';
import Link from 'redux-first-router-link';

const getFormFieldCfgs = ({ kodif, searchAction }) => {
    let prevAtradnesId = null;
    let initialFormAtradnesId;
    let prevAtradnesIdForGeom = null;

    return [
        {
            name: 'kods',
            label: 'Sateces baseina kods',
            renderClassName: "bold",
            extraFieldProps: () => ({ placeholder: 'Tiks piešķirts nākamais brīvais', disabled: true }),
            renderer: (fieldValue, dataObj) => dataObj.ir_arhivets
                ? <span className="cross-out">{fieldValue}</span>
                : fieldValue
        }, {
            name: 'udensapgades_sistema',
            label: 'Ūdensapgādes sistēma',
            customField: (props) => {
                const { setFieldValue } = props
                const setUasData = (field, newUas) => {
                    if (newUas && newUas.tah_id && newUas.nosaukums && newUas.operators) {
                        setFieldValue('udensapgades_sistemas_id', newUas.tah_id)
                        setFieldValue('nosaukums', newUas.nosaukums)
                        setFieldValue('operators', newUas.operators)
                        setFieldValue('atlaujas_nr', newUas.atlaujas_nr)
                    }
                }
                return <TypeaheadField
                    fieldName="udensapgades_sistemas_search"
                    setFieldValue={setUasData}
                    autocompleteCfg={{
                        remoteSearchViewName: 'udensapgades_sistemas_search',
                        isValueObjStructure: true
                    }}
                    extraFieldProps={{
                        placeholder: 'Meklēt esošu ūdensapgādes sistēmu'
                    }}
                />
            }
        }, {
            name: 'nosaukums',
            label: 'Ūdensapgādes sistēmas nosaukums',
            renderClassName: "bold",
            extraFieldProps: () => ({ disabled: true }),
            renderer: (fieldValue, dataObj) => dataObj.ir_arhivets
                ? <span className="cross-out">{fieldValue}</span>
                : fieldValue
        }, {
            name: 'operators',
            extraFieldProps: () => ({ disabled: true })
        }, {
            name: 'atlaujas_nr',
            extraFieldProps: () => ({ disabled: true })
        }, {
            name: 'platiba',
            type: 'number',
            label: 'Sateces baseina platība, ha',
            renderer: getNumberFormatter(),
            editable: false
        }, {
            name: 'urbumi_atradnes_id',
            label: 'Piederība pazemes ūdeņu atradnei',
            type: 'autocomplete',
            autocompleteCfg: {
                remoteSearchViewName: 'dzerama_udens_sateces_baseins_pazemes_udenu_atradne_search',
                labelFieldName: 'urbumi_atradnes_nosaukums'
            },
            renderer: (nos, row) => (
                <Link to={{
                    type: 'loc_urbumu_atradne',
                    payload: { id: row.urbumi_atradnes_id }
                }}>
                    {row.urbumi_atradnes_nosaukums}
                </Link>
            )
        }, {
            name: 'udens_ieguves_vietas',
            label: 'Ūdens ieguves vietas DB nr.',
            customField: (props) => {
                const { currentValues, setFieldValue } = props
                const atradnesId = currentValues.urbumi_atradnes_id

                if (initialFormAtradnesId === undefined) {
                    initialFormAtradnesId = atradnesId
                }

                if (atradnesId !== prevAtradnesId) {
                    prevAtradnesId = atradnesId
                    if (atradnesId) {
                        if (initialFormAtradnesId && atradnesId === initialFormAtradnesId && currentValues.id) {
                            initialFormAtradnesId = null
                        } else {
                            searchAction('', {
                                onRemoteSuccess: (urbumi) => {
                                    setFieldValue('udens_ieguves_vietas', urbumi.map(urb => ({
                                        urbumi_id: urb.urbumi_id,
                                        tah_id: urb.urbumi_id,
                                        tah_label: urb.tah_label,
                                        nr_pirmavota: urb.nr_pirmavota,
                                        adrese: urb.adrese,
                                        organizacija: urb.organizacija,
                                        tehniskais_stavoklis: urb.tehniskais_stavoklis
                                    })))
                                },
                                onRemoteFailure: () => {
                                    setFieldValue('udens_ieguves_vietas', [])
                                }
                            }, 'dzerama_udens_sateces_baseins_urbumi_by_atradne_search', { atradnes_id: String(atradnesId) })
                        }
                    } else {
                        setTimeout(() => setFieldValue('udens_ieguves_vietas', []), 0)
                    }
                }

                const selectedIds = new Set(
                    (Array.isArray(currentValues.udens_ieguves_vietas) ? currentValues.udens_ieguves_vietas : [])
                        .map(v => v.urbumi_id)
                )
                const filterBy = (option) => !selectedIds.has(option.tah_id)

                if (atradnesId) {
                    return <TypeaheadField {...props}
                        key={`atradne-${atradnesId}`}
                        fieldName="udens_ieguves_vietas"
                        autocompleteCfg={{
                            multiple: true,
                            keyField: 'urbumi_id',
                            initialOptionsViewName: 'dzerama_udens_sateces_baseins_urbumi_by_atradne_search',
                            isValueObjStructure: true,
                            extraFilterParams: { atradnes_id: atradnesId }
                        }}
                        extraFieldProps={{
                            filterBy, emptyLabel: 'Pieejamie urbumi jau pievienoti', minLength: 0
                        }}
                    />
                }

                return <TypeaheadField {...props}
                    key="no-atradne"
                    fieldName="udens_ieguves_vietas"
                    autocompleteCfg={{
                        multiple: true,
                        keyField: 'urbumi_id',
                        remoteSearchViewName: 'dzerama_udens_sateces_baseins_urbumi_by_atradne_search',
                        isValueObjStructure: true
                    }}
                    extraFieldProps={{
                        filterBy, emptyLabel: 'Pieejamie urbumi jau pievienoti'
                    }}
                />
            },
            renderer: (fieldValue, dataObj) => (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem 0.8rem' }}>
                    {fieldValue.map((urb, i) =>
                        <Link
                            key={i}
                            to={{
                                type: 'loc_urbums',
                                payload: {
                                    id: urb.urbumi_id,
                                }
                            }}>
                            {urb.urbumi_id}
                        </Link>
                    )}
                </div>
            )
        }, {
            name: 'pazemes_udenu_objekti',
            label: 'Pazemes ūdensobjekts',
            type: 'autocomplete',
            autocompleteCfg: {
                multiple: true,
                keyField: 'udens_objekts_id',
                initialOptionsViewName: 'dzerama_udens_sateces_baseins_pazemes_udenu_objekti_search',
                extraFilterParams: {},
                isValueObjStructure: true
            },
            renderer: (fieldValue, dataObj) => (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem 0.8rem' }}>
                    {fieldValue.map((puo, i) =>
                        <Link
                            key={i}
                            to={{
                                type: 'loc_pazemes_udens_objekts',
                                payload: {
                                    kods: puo.kods,
                                }
                            }}>
                            {puo.kods}
                        </Link>
                    )}
                </div>
            )
        }, {
            name: 'urbumi_atradnes_geom_id',
            label: 'Atradnes ģeometrija',
            type: 'autocomplete',
            autocompleteCfg: {
                keyField: 'geom_id',
                labelFieldName: 'urbumi_atradnes_geom_nosaukums',
                initialOptionsViewName: 'urbumi_atradnes_geom_search',
                extraFilterParams: {},
            },
            overridePropsFunc: (props) => {
                const { currentValues, setFieldValue } = props
                const uaId = currentValues.urbumi_atradnes_id

                if (!uaId) {
                    return {
                        ...props,
                        extraFieldProps: { disabled: true }
                    }
                }

                if (uaId !== prevAtradnesIdForGeom) {
                    prevAtradnesIdForGeom = uaId
                    searchAction('', {
                        onRemoteSuccess: (geomOptions) => {
                            if (geomOptions && geomOptions.length > 0) {
                                let selectedGeom = geomOptions.find(option => option.aizsargjosla === 'K')
                                if (!selectedGeom) {
                                    selectedGeom = geomOptions.find(option => option.aizsargjosla === 'A')
                                }
                                if (!selectedGeom) {
                                    selectedGeom = geomOptions[0]
                                }

                                if (selectedGeom) {
                                    setFieldValue('urbumi_atradnes_geom_nosaukums', selectedGeom.tah_label)
                                    setFieldValue('urbumi_atradnes_geom_id', selectedGeom.tah_id)
                                }
                            } else {
                                setFieldValue('urbumi_atradnes_geom_id', null)
                            }
                        },
                        onRemoteFailure: () => {
                            setFieldValue('urbumi_atradnes_geom_id', null)
                        }
                    }, 'urbumi_atradnes_geom_search', { ua_id: uaId })
                }

                return {
                    ...props,
                    autocompleteCfg: {
                        ...props.autocompleteCfg,
                        extraFilterParams: { ua_id: uaId }
                    },
                    extraFieldProps: { disabled: false }
                }
            },
            renderer: (nos, row) => row.urbumi_atradnes_geom_nosaukums
        }, {
            ...getKlasifikatorsFieldCfg(kodif, 'dzeramaUdensSatecesBaseiniKategorija'),
            name: 'kategorija',
            renderer: getFormatterForKodif(kodif.dzeramaUdensSatecesBaseiniKategorija)
        }, {
            name: 'ter_iedalijums_wfs',
            label: 'Administratīvā teritorija',
            editable: false,
            fieldNotes: 'Administratīvās un teritoriālās vienības tiek aizpildītas automātiski no WFS servisa pēc ģeometrijas labošanas.',
            renderer: (allAdm, vals) => {
                // group by limenis_1
                const grouped = allAdm.reduce((grouped, adm) => {
                    if (!grouped[adm.limenis_1]) {
                        grouped[adm.limenis_1] = []
                    }
                    if (adm.limenis_2) {
                        grouped[adm.limenis_1].push(adm.limenis_2)
                    }
                    return grouped
                }, {})
                return <>
                    {Object.keys(grouped).map(adm => <p key={adm} className="links">{adm}{grouped[adm].length > 0 ? ' - ' + grouped[adm].join('; ') : null}</p>)}
                    {vals.baseins_ter_iedalijums_wfs_kluda ? <p className="danger links">{vals.baseins_ter_iedalijums_wfs_kluda}</p> : null}
                </>
            }
        }
    ]
}

class BaseinsInfo extends Component {

    handleToggleArhivets = () => {
        const { dzeramaUdensSatecesBaseins, toggleArhivets } = this.props
        const { selectedItem } = dzeramaUdensSatecesBaseins
        if (!selectedItem) return
        const next = !selectedItem.ir_arhivets
        const msg = next
            ? 'Vai tiešām vēlaties arhivēt šo sateces baseinu? Arhivētu baseinu nevar rediģēt.'
            : 'Vai tiešām vēlaties atjaunot šo sateces baseinu no arhīva?'
        if (!window.confirm(msg)) return
        toggleArhivets(selectedItem.id, next)
    }

    render() {

        const { dzeramaUdensSatecesBaseins, kodif, user } = this.props

        const { selectedItem, editable, submiting } = dzeramaUdensSatecesBaseins

        if (!selectedItem) {
            return (<Loading />)
        }

        if (!this.formFieldCfgs) {
            this.formFieldCfgs = getFormFieldCfgs({
                kodif: kodif,
                searchAction: this.props.searchAction
            })
        }

        const alwaysVisibleFields = ['kods', 'nosaukums', 'operators', 'atlaujas_nr']
        const platibaIndex = this.formFieldCfgs.findIndex(cfg => cfg.name === 'platiba')
        const visibleFields = this.formFieldCfgs.filter((cfg, index) => {
            const val = selectedItem[cfg.name]
            if (editable) return true
            if (alwaysVisibleFields.includes(cfg.name)) return true
            if (index < platibaIndex) {
                if (val === null || val === undefined) return false
                if (Array.isArray(val) && val.length === 0) return false
                if (typeof val === 'string' && val.trim() === '') return false
            }
            return true
        })

        const isArhivets = !!selectedItem.ir_arhivets
        const canToggleArhivets = user?.tiesibas?.includes('SATECES_BASEINI_ARHIVET')

        const arhivetButton = canToggleArhivets && !editable ? (
            <Button
                color={isArhivets ? 'success' : 'warning'}
                onClick={this.handleToggleArhivets}
                className="float-right"
            >
                <i className={`fa fa-${isArhivets ? 'undo' : 'archive'}`}></i>
                &nbsp;&nbsp;{isArhivets ? 'Atjaunot no arhīva' : 'Arhivēt'}
            </Button>
        ) : null

        return <div className="form-container">
            <Form
                // editable={false}
                editable={editable}
                submiting={submiting}
                dataObj={selectedItem}
                formFieldCfgs={visibleFields}
                metadataFormCfg="dzerama_udens_sateces_baseins_view"
                onSubmit={this.props.saveAct}
                onReset={this.props.stopEditAct}
                onStartEdit={isArhivets ? null : this.props.startEditAct}
                onDelete={!isArhivets && user.tiesibas.includes('SATECES_BASEINI_DZEST') ? this.props.deleteAct : null}
                tiesibasLabot="SATECES_BASEINI_LABOT"
                extraElements={arhivetButton}
            />
        </div>
    }
}

const mapStateToProps = ({ dzeramaUdensSatecesBaseins, kodif, user }) => ({ dzeramaUdensSatecesBaseins, kodif, user })

const DzeramaUdensSatecesBaseinsInfo = connect(mapStateToProps, { ...dzeramaUdensSatecesBaseinsActions, dzeramaUdensSatecesBaseinsInMapSelected, searchAction, toggleArhivets: toggleDzeramaUdensSatecesBaseinsArhivets })(BaseinsInfo)
export default DzeramaUdensSatecesBaseinsInfo
